import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { FAMILIES, type FamilyKey } from "@/data/activation-families";
import { cn } from "@/lib/utils";
import { FAMILY_ICONS } from "@/data/activation-icons";

/** The four activation types as cards with their one-line descriptions. Used wherever a brand starts a brief or an activation. */
const FamilyPickerDialog = ({ open, onOpenChange, families, onPick, title, description, showDescriptions = true }: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  families: FamilyKey[];
  onPick: (family: FamilyKey) => void;
  title: string;
  description?: string;
  /** Cards show each type's one-line description by default; turn off for a plain list of titles. */
  showDescriptions?: boolean;
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-xl">
      <DialogHeader>
        <DialogTitle>{title}</DialogTitle>
        {description && <DialogDescription>{description}</DialogDescription>}
      </DialogHeader>
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
        {families.map((f) => {
          const Icon = FAMILY_ICONS[f];
          return (
            <button
              key={f}
              type="button"
              onClick={() => { onOpenChange(false); onPick(f); }}
              className={cn(
                "rounded-xl border border-border bg-white p-4 text-left transition hover:border-foreground/30 hover:bg-muted/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
                showDescriptions ? "flex flex-col items-start gap-1.5" : "flex items-center gap-3",
              )}
            >
              <Icon className="h-5 w-5" />
              <span className="text-[15px] font-medium text-foreground">{FAMILIES[f].label}</span>
              {showDescriptions && <span className="text-[13px] leading-snug text-muted-foreground">{FAMILIES[f].pickerHint}</span>}
            </button>
          );
        })}
      </div>
    </DialogContent>
  </Dialog>
);

export default FamilyPickerDialog;
